var $ = require('jquery');
require('./highslide-settings');
'use strict';

var PLUGIN_NAME = 'gallerySupport';

var	DEFAULTS = {
	type: 'standard',
	thumbSelector: ''
};

var GallerySupport = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;

	this.$target = null;
	this.$thumbs = [];
	this.actualThumbIndex = 0;

	this.initialise_();
};

GallerySupport.prototype.initialise_ = function() {

	this.getImages_();

	if (this.options.type == 'standard') {
		this.getTarget_();
		this.openImage_(0);
		this.bindStandardGalleryThumbs_();
	}
};

GallerySupport.prototype.getTarget_ = function() {
	this.$target = $(this.$t.data('target'));
};

GallerySupport.prototype.getImages_ = function() {
	this.$thumbs = $(this.options.thumbSelector, this.$t);
};

GallerySupport.prototype.openImage_ = function(index) {
	$(this.$thumbs).css({
		opacity: 1
	});
	$(this.$thumbs[index]).css({
		opacity: 0.7
	});

	var mediumThumb = $(this.$thumbs[index]).data('medium') || $(this.$thumbs[index]).attr('href');

	this.preloadImage_(mediumThumb, $(this.$thumbs[index]));
};

GallerySupport.prototype.preloadImage_ = function(path, $thumb) {
	var self_ = this;
	var image = new Image();
	image.src = path;
	$(image).load(function() {
		self_.$target.animate({opacity: 0}, 200, function() {
			self_.renderImage_(path, $thumb);
		});
	});

};

GallerySupport.prototype.renderImage_ = function(path, $thumb) {
	var self_ = this;
	this.$target.empty();
	this.$mediumThumb = $('<a href="'+$thumb.attr('href')+'" id="mediumThumbnail"></a>').appendTo(this.$target);
	this.$mediumThumb.html('<img data-title="'+$('img', $thumb).data('title')+'" alt="'+$('img', $thumb).attr('alt')+'" class="img-responsive" src="' + path + '">');
	this.$mediumThumb.on('click', function(event) {
		event.preventDefault();
		$(document).data('hsStandardGalleryEnabled', '1');
		return hs.expand($(self_.$thumbs[self_.actualThumbIndex])[0], { thumbnailId : 'mediumThumbnail'});
	});
	this.$target.animate({ opacity: 1}, 200);
};

GallerySupport.prototype.bindStandardGalleryThumbs_ = function() {
	var self_ = this;
	// prevent drag'n'drop
	this.$t.on('mousedown', this.options.thumbSelector, function(event) {
		event.preventDefault();
	});
	this.$t.on('click', this.options.thumbSelector, function(event) {
		event.preventDefault();
		var index = parseInt($(event.currentTarget).data('index')) || 0;
		if (index === self_.actualThumbIndex) {
			return false;
		}

		self_.actualThumbIndex = index;
		self_.openImage_(index);
		return false;
	})
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new GallerySupport(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.gallery-support.js